export class statusdto {
    statusesid: string | undefined;
    usercreated: string | undefined;
    datecreated: string | undefined;
    userupdated: string | undefined;
    dateupdated: string | undefined;
    deletedyn: boolean | false;
    code: string | undefined;
    status: string | undefined;
    description: string | undefined;
}